import { useAuth } from "../Contexts/AuthContext";
import NoMedicalResult from "./NoMedicalResult";
import LabResult from "../assets/labresult.png";
import InfoIcon from "@mui/icons-material/Info";
import { useNavigate } from "react-router-dom";
import ErrorComponent from "./ErrorComponent";
import { Tooltip } from "@mui/material";
import React, { useState } from "react";
import PropTypes from "prop-types";
import dayjs from "dayjs";

export default function MedicalTestResults({
  medicalTestLoadState,
  medicalTestsList,
  getMedicalTests,
}) {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const [tooltipIndex, setTooltipIndex] = useState(-1);

  const { userData, getMemberStatus, memberStatus, memberStatusLoadState } = useAuth();

  const navigate = useNavigate();

  const getMedTestOwner = (item) => {
    let index = userData.findIndex((e) => {
      return e.cardNo === item.cardNo;
    });
    if (index >= 0) {
      return (
        <div>
          <p>{`${userData[index].firstName} ${userData[index].lastName}`}</p>
          <p>{item.cardNo}</p>
        </div>
      );
    }
    return <div>...</div>;
  };

  const handleTooltipOpen = (i) => {
    if (tooltipIndex === i && isTooltipOpen) {
      setIsTooltipOpen(false);
      setTooltipIndex(-1);
    } else {
      setIsTooltipOpen(true);
      setTooltipIndex(i);
    }
  };

  const renderStatusColor = (status) => {
    if (status.toLowerCase() === "pending") {
      return "text-[#0947ab] bg-[#c4d6f2]";
    } else if (status.toLowerCase() === "completed") {
      return "text-[#337951] bg-[#d7efe1]";
    } else if (status.toLowerCase() === "cancelled") {
      return "text-[#c22020] bg-[#ffd1d1]";
    }
  };

  const getParams = (item) => {
    let params = "&transactionType=Procedures";

    if (item.transactionId) {
      params = params + `&transactionId=${item.transactionId}`;
    }

    if (item.referenceId) {
      params = params + `&referenceId=${item.referenceId}`;
    }

    if (item.appointmentId) {
      params = params + `&appointmentId=${item.appointmentId}`;
    }

    if (item.dateTime) {
      params = params + `&dateTime=${item.dateTime}`;
    }

    return params;
  };

  const handleViewTransaction = async (item) => {
    navigate(`/transaction-history?cardNo=${item.cardNo}${getParams(item)}`);
  };

  const handleRetry=()=>{
    getMedicalTests("retry");
    //wont fetch again if already got the member status response
    if(memberStatus.status !== "success" && memberStatusLoadState !== "load"){
      getMemberStatus();
    }
  }

  let medTests = null;
  if (medicalTestsList.length > 0) {
    medTests = (
      <div className="p-2">
        {medicalTestsList.map((item, index) => (
          <div
            className="flex border rounded-lg items-start gap-3 p-5 mb-4"
            key={`${item.cardNo}_${item.dateTime}`}
          >
            <img src={LabResult} alt="Lab result" className="w-10 h-10" />
            <div className="flex-1">
              <div className="flex items-start justify-between w-full">
                <div className="flex items-start">
                  <button
                    className="font-bold text-left text-md capitalize line-clamp-2 sm:line-clamp-3"
                    onClick={() => handleViewTransaction(item)}
                  >
                    {item.name.toLowerCase()}
                  </button>
                  <Tooltip
                    PopperProps={{
                      disablePortal: true,
                    }}
                    open={isTooltipOpen && tooltipIndex === index}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    title={getMedTestOwner(item)}
                  >
                    <button
                      className="ml-2 mb-1"
                      onClick={() => handleTooltipOpen(index)}
                    >
                      <InfoIcon sx={{ color: "#2d6fd9", fontSize: 16 }} />
                    </button>
                  </Tooltip>
                </div>
                <div
                  className={`rounded-full text-[14px] font-bold px-3 w-fit ml-2 ${renderStatusColor(
                    item.status
                  )}`}
                >
                  {item.status}
                </div>
              </div>
              <p className="text-gray-400 text-sm">
                {`Performed ${dayjs(item.dateTime).format("MMMM DD, YYYY")} • ${dayjs(item.dateTime).format("h:mm A")}`}
              </p>
            </div>
          </div>
        ))}
      </div>
    );
  } else {
    medTests = <NoMedicalResult />;
  }

  let content = null;
  if (["ISE", "retry", "timeout"].includes(medicalTestLoadState)) {
    content = (
      <ErrorComponent
        onRetry={handleRetry}
        isLoading={medicalTestLoadState === "retry"}
      />
    );
  } else {
    content = medTests;
  }

  return content;
}

MedicalTestResults.propTypes = {
  medicalTestsList: PropTypes.any,
};
